import { Directive, ElementRef, Input, OnChanges, OnDestroy, SimpleChanges, inject } from '@angular/core';

@Directive({
  selector: 'img[appImagePreview], [appQuestionImagePreview]',
  standalone: false,
})
export class ImagePreviewDirective implements OnChanges, OnDestroy {
  private el = inject(ElementRef);

  @Input() image: any;
  url: string | null = null;

  ngOnChanges(changes: SimpleChanges) {
    const el = this.el;

    if (this.image) {
      this.url = URL.createObjectURL(this.image);
      el.nativeElement.src = this.url;
    }
  }

  ngOnDestroy(): void {
    if (this.url) URL.revokeObjectURL(this.url);
  }
}
